import { render, staticRenderFns } from "./Register-colaborador.vue?vue&type=template&id=40e47c6a&scoped=true&"
import script from "./Register-colaborador.vue?vue&type=script&lang=js&"
export * from "./Register-colaborador.vue?vue&type=script&lang=js&"
import style0 from "./Register-colaborador.vue?vue&type=style&index=0&id=40e47c6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e47c6a",
  null
  
)

export default component.exports